<template>
  <div class="asr">
    <div class="asr-container">
      <div class="asr-wrap">
        <div class="asr-block-form">
          <div class="asr-form-create">
            <div class="row asr-block-title">
              <div class="col-md-12">
                <h2 class="asr-form-title">
                  {{ appName }}
                </h2>
                <p class="asr-form-sub-title">
                  {{ $t('string.welcome_back') }}
                </p>
              </div>

              <div
                v-if="isLoginFail"
                class="col-md-12"
              >
                <div
                  class="alert alert-danger alert-dismissible"
                  role="alert"
                >
                  <button
                    aria-label="Close"
                    class="close"
                    data-dismiss="alert"
                    type="button"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p>{{ messageLoginFail }}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 form-group"
                :class="{'has-error' : validations.username}"
              >
                <input
                  v-model="credentials.username"
                  :placeholder="$t('label.username')"
                  class="form-control"
                  type="text"
                >
                <template v-if="validations.username">
                  <span class="label-error">
                    {{ validations['username'][0] }}
                  </span>
                </template>
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 form-group"
                :class="{'has-error' : validations.password}"
              >
                <input
                  v-model="credentials.password"
                  :placeholder="$t('label.password')"
                  class="form-control"
                  type="password"
                >
                <template v-if="validations.password">
                  <span class="label-error">
                    {{ validations['password'][0] }}
                  </span>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 item-center margin-bottom">
                <button
                  class="btn btn-primary btn-block capitalize btn-login slide"
                  @click="onClickLogin"
                >
                  {{ $t('button.login') }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p class="text-center">
                  <a href="/">Asorasoft.com</a> © {{ (new Date).getFullYear() }}.
                  {{ $t('string.right_reserved') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="asr-block-img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  metaInfo () {
    return {
      title: this.$t('string.login'),
      titleTemplate: '%s | ' + this.appName
    }
  },
  data () {
    return {
      appName: process.env.VUE_APP_NAME,
      credentials: {
        username: '',
        password: ''
      },
      validations: {},
      isLoginFail: false,
      messageLoginFail: '',
      config: process.env
    }
  },
  mounted () {
    window.addEventListener('keypress', this.onPressEnter)
  },
  destroyed () {
    window.removeEventListener('keypress', this.onPressEnter)
  },
  methods: {
    onClickLogin () {
      const self = this

      self.isLoginFail = false
      this.messageLoginFail = ''
      self.validations = {}
      self.$isLoading(true)

      self.$axios.post(process.env.VUE_APP_API + '/api/auth/backend/login', self.credentials)
        .then(({ data }) => {
          if (data.data) {
            const {
              access_token,
              refresh_token,
              user,
              roles,
              permissions
            } = data.data

            localStorage.setItem(this.$token, access_token)
            localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN, refresh_token)

            self.$axios.defaults.headers.common.Authorization = 'Bearer ' + access_token
            self.$axios.defaults.headers.common.Accept = 'application/json'

            $.ajaxSetup({
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem(this.$token)
              }
            })

            self.$store.dispatch('user/setUser', { user })
            self.$store.dispatch('user/setRoles', roles)
            self.$store.commit('user/setPermissions', permissions)

            self.$router.push({
              name: 'admin',
              path: localStorage.getItem('fromRoutePath')
            })
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            self.validations = error.response.data.errors
          } else {
            this.isLoginFail = true
            const message = error.response.data.message
            this.messageLoginFail = message['message_' + this.$i18n.locale]
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    onPressEnter (e) {
      if (e.code === 'Enter') {
        this.onClickLogin()
      }
    }
  }
}
</script>

<style scoped>
@import "../assets/css/login.css";

.alert {
  margin-bottom: unset;
}
</style>
